import React from 'react'


import Slider from '../components/Slider';
import Homeabout from '../homepage/Homeabout';
import Common from '../components/Common';
import Footer from '../components/Footer';
import Whychoiseus from '../homepage/Whychoiseus';
export default function Home() {
  return (
    <div>
     <Common/>
      <Slider></Slider>
      <Homeabout/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>

      <Whychoiseus/>
      <Footer/>
    </div>
  )
}
